import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { isDefined } from '@sama/js-core';
import { filter, map } from 'rxjs/operators';
import { isPointCloudOutput } from '../../../../../../../cross-team-shared/misc-utils/output-utils';
import { getOutputByName } from '../../../../../../h3ml/dsl/sensor-fusion/sensor-fusion-output.utils';
import { SettingsService } from '../../../../../../h3ml/dsl/sensor-fusion/view-settings/settings.service';
import { TaskWorkspaceStore } from '../../../../../../h3ml/state/task-workspace-store';
import { resetZoomIcon } from '../../../../../../shared/icons/toolbars/reset-zoom-icon';
import { RootKeyboardShortcutService } from '../../../../../../shared/keyboard-shortcuts/root-keyboard-shortcut.service';

@Component({
  selector: 'h3-reset-sensor-view-button',
  templateUrl: './reset-sensor-view-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ResetSensorViewButtonComponent {
  private readonly settingsService = inject(SettingsService);
  private readonly taskWorkspaceStore = inject(TaskWorkspaceStore);
  private readonly keyBoardShortcutService = inject(
    RootKeyboardShortcutService,
  );
  selectedOutputName$ = this.taskWorkspaceStore('selectedOutputName').$;
  toolTip$ = this.selectedOutputName$.pipe(
    filter(isDefined),
    map((outputName) => {
      const output = getOutputByName(
        this.taskWorkspaceStore.state().project,
        outputName,
      );
      const shortcut =
        this.keyBoardShortcutService.tooltipSuffix('resetSensorView');
      if (isPointCloudOutput(output)) {
        return 'Reset camera' + shortcut;
      }
      return 'Reset zoom' + shortcut;
    }),
  );
  resetZoomIcon = resetZoomIcon;

  resetSensorView() {
    this.settingsService.resetSensorView({ source: 'button' });
  }
}
